// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    font-family: 'Albert Sans', sans-serif;
    color: #1F405A;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    height: 100%;
}

* {
    font-family: inherit;
    color: inherit;
}

.dashboard-container {
    display: flex;
    height: 100vh;
}

.sidebar {
    background-color: #1F405A;
    width: 30%;
    max-width: 435px;
    padding: 2rem;
    color: white;
    display: flex;
    flex-direction: column;
}

.title {
    font-size: 1.9rem;
    margin-top: 1rem;
    color: white;
    text-align: justify;
    font-family: 'Albert Sans', sans-serif;
}

.illustration {
    margin-top: auto;
    align-self: flex-start;
    max-width: 100%;
    height: auto;
}

.login-image {
    width: 21.875rem;
    height: 18.75rem;
    object-fit: cover; 
}

.welcome-message {
    margin-top: 1.5rem;
    color: white;
    font-size: 1.2rem;
}

.main-content {
    background-color: rgb(243, 248, 250);
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.login-container {
    background-color: white;
    width: 50%;
    padding: 1.5rem;
    border-radius: 0.5625rem;
    box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/supplierHome/LoginOutlet.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,cAAc;IACd,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,eAAe;IACf,wBAAwB;IACxB,iDAAiD;AACrD","sourcesContent":["body, html {\n    font-family: 'Albert Sans', sans-serif;\n    color: #1F405A;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    height: 100%;\n}\n\n* {\n    font-family: inherit;\n    color: inherit;\n}\n\n.dashboard-container {\n    display: flex;\n    height: 100vh;\n}\n\n.sidebar {\n    background-color: #1F405A;\n    width: 30%;\n    max-width: 435px;\n    padding: 2rem;\n    color: white;\n    display: flex;\n    flex-direction: column;\n}\n\n.title {\n    font-size: 1.9rem;\n    margin-top: 1rem;\n    color: white;\n    text-align: justify;\n    font-family: 'Albert Sans', sans-serif;\n}\n\n.illustration {\n    margin-top: auto;\n    align-self: flex-start;\n    max-width: 100%;\n    height: auto;\n}\n\n.login-image {\n    width: 21.875rem;\n    height: 18.75rem;\n    object-fit: cover; \n}\n\n.welcome-message {\n    margin-top: 1.5rem;\n    color: white;\n    font-size: 1.2rem;\n}\n\n.main-content {\n    background-color: rgb(243, 248, 250);\n    width: 70%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n}\n\n.login-container {\n    background-color: white;\n    width: 50%;\n    padding: 1.5rem;\n    border-radius: 0.5625rem;\n    box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
